import { useMemo } from 'react';
import type { ScriptBlockData } from './ScriptBlock';
import { layoutScreenplay, type ScriptPage } from '../../lib/scriptLayout';
import {EMPTY_SCRIPT_FORMAT,type ScriptFormatSource} from '../../lib/scriptFormat';

export type PageData = ScriptPage;
export const paginateBlocks = (blocks:readonly ScriptBlockData[],format:ScriptFormatSource=EMPTY_SCRIPT_FORMAT):PageData[] => layoutScreenplay(blocks,format).pages;
export const usePagination = (blocks:readonly ScriptBlockData[],format:ScriptFormatSource=EMPTY_SCRIPT_FORMAT):PageData[] =>
    useMemo(() => paginateBlocks(blocks,format),[blocks,format]);
// Kept for existing status/statistics callers; this is now the actual layout count.
export const estimatePageCount = (blocks:readonly ScriptBlockData[],format:ScriptFormatSource=EMPTY_SCRIPT_FORMAT):number => paginateBlocks(blocks,format).length;
